﻿function getCurrentState() {
    const history = window.History;
    return history.getState();
}

function sendPageView(event) {
    const state = getCurrentState();
    if (state.data.doNotSendPageView) {
        return;
    }
    window.sendPageView();
}

function reloadAds(event) {
    const shouldReload = $("#main-content").data('should-reload-on-statechange');

    if (shouldReload) {
        const adSection = $("[data-ad-id]");
        const page = window.getDFPAdsPage(adSection);
        window.getDFPAds(page);
    }
}

export function setupStateChange() {

    const history = window.History;
    history.Adapter.bind(window, "statechange", sendPageView);
    history.Adapter.bind(window, "statechange", reloadAds);

    window.sendPageView = function () {
        let url = window.location.pathname + window.location.search;
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "pageview", url);
        }
        $(window).trigger('send-page-view', url);
    };
}

